import React from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import user, { useUser } from '../../../redux/reducer/user';
import useTimerWrapper from '../../../hooks/useTimerWrapper';
import { timeToString } from '../../../hooks/useTimer';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import requests from '../../../redux/reducer/requests';

export default function AddFriendForm({ slots, data, onSubmit }) {
  const { numberInputs = [], inputs = [], checkboxes = [], radio = [] } = slots;
  const { subtitle, sign, send, button, time, form, checkbox, text, callbacks } = data;
  const { timerUuid } = useUser();
  const { time: lefTime } = useTimerWrapper(timerUuid);
  const dispatch = useDispatch();

  return (
    <form onSubmit={onSubmit} className={'add-friend-modal__form'}>
      {inputs.map(WrapCheck)}
      {/*{
        (data.addFriendRequest?.error?.code === 404 && data.addFriendRequest?.error?.message === "Not Found") &&
        <p className="add-friend-modal__text-error">{safeHTML("Мы&nbsp;не&nbsp;нашли пользователя с&nbsp;данным&nbsp;ID")}</p>
      }*/}
      {button && <CustomButton {...button} />}
    </form>
  );

  function WrapCheck(item, index) {
    const { key } = item;
    const keyStr = `${key}-${index}`;
    if (typeof item.props.Wrapper === 'function') {
      return item.props.Wrapper(item, item.props, keyStr);
    }
    return item;
  }
}
